/** @format */

import { useState } from "react";
import { RsvpContainer, SignUpForm } from "./styled-components";
import StartPage from "./View/StartPage";
import ContactInfoPage from "./View/ContactInfo/index";
import CabinPage from "./View/CabinPage/index";
import ConfirmPage from "./View/ConfirmPage";
import AdditionalPage from "./View/AdditionalPage/index";
import { steps } from "./Model";

export default function RSVP() {
  const [currentStep, setCurrentStep] = useState(steps.start);

  function progressFlow(rsvp) {
    window.scrollTo(0, 0);
    switch (currentStep) {
      case steps.start:
        setCurrentStep(steps.contact);
        break;
      case steps.contact:
        if (rsvp === "no") {
          setCurrentStep(steps.confirm);
        } else {
          setCurrentStep(steps.cabin);
        }
        break;
      case steps.cabin:
        setCurrentStep(steps.additional);
        break;
      case steps.additional:
        setCurrentStep(steps.confirm);
        break;
      default:
        setCurrentStep(steps.start);
    }
  }

  function regressFlow() {
    window.scrollTo(0, 0);
    switch (currentStep) {
      case steps.contact:
        setCurrentStep(steps.start);
        break;
      case steps.cabin:
        setCurrentStep(steps.contact);
        break;
      case steps.additional:
        setCurrentStep(steps.cabin);
        break;
      case steps.confirm:
        setCurrentStep(steps.additional);
        break;
      default:
        setCurrentStep(steps.start);
    }
  }

  function contentToDisplay() {
    switch (currentStep) {
      case steps.start:
        return <StartPage progressFlow={progressFlow} />;
      case steps.contact:
        return (
          <ContactInfoPage
            regressFlow={regressFlow}
            progressFlow={progressFlow}
          />
        );

      case steps.cabin:
        return (
          <CabinPage regressFlow={regressFlow} progressFlow={progressFlow} />
        );

      case steps.additional:
        return (
          <AdditionalPage
            progressFlow={progressFlow}
            regressFlow={regressFlow}
          />
        );

      case steps.confirm:
        return <ConfirmPage />;
      default:
        setCurrentStep(steps.start);
    }
  }

  return (
    <>
      <RsvpContainer>
        <SignUpForm>{contentToDisplay()}</SignUpForm>
      </RsvpContainer>
    </>
  );
}
